declare global {
  interface Navigator {
    msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean
  }
}

export function exportToExcel(tableHtml: string, filename = '') {
  const downloadLink = document.createElement('a')
  const dataType = 'application/vnd.ms-excel'
  const html = tableHtml.replace(/\s/g, '%20')

  // Specify file name
  const newFilename = filename ? filename + '.xls' : 'excel_data.xls'

  document.body.appendChild(downloadLink)

  if (navigator.msSaveOrOpenBlob) {
    const blob = new Blob(['\ufeff', html], {
      type: dataType,
    })
    navigator.msSaveOrOpenBlob(blob, newFilename)
  } else {
    // Create a link to the file
    downloadLink.href = 'data:' + dataType + ', ' + html

    // Setting the file name
    downloadLink.download = newFilename

    //triggering the function
    downloadLink.click()
  }
}
